import * as Yup from 'yup'

export const DefaultContactValidationSchema = Yup.object({
  name: Yup.string().required(),
  email: Yup.string().required().email(),
  phoneNumber: Yup.string().nullable(),
})